import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Tab Thông Báo Tuyển Dụng (`notifications`)
 * Cập nhật biến động thời gian thực về hồ sơ, lịch hẹn và thay đổi trạng thái tuyển dụng.
 */
export const RecruiterNotificationsTab: React.FC = () => {
  return (
    <div className="space-y-6 animate-fade-in text-left">
      <div className="border-b pb-5">
        <h1 className="font-display font-bold text-2xl text-gray-900 leading-tight">Thông báo tuyển dụng</h1>
      </div>

      <div className="bg-white rounded-3xl border border-gray-100 shadow-sm overflow-hidden divide-y divide-gray-100">
        {[
          {
            title: 'Hồ sơ ứng tuyển mới',
            message: 'Ứng viên Trần Thị Minh Anh đã nộp hồ sơ cho tin Thiết kế UI/UX.',
            time: '10 phút trước',
            unread: true,
          },
          {
            title: 'Lịch phỏng vấn thay đổi',
            message: 'Lịch phỏng vấn của Nguyễn Hoàng Nam được dời sang 10:00 ngày 02/06.',
            time: '2 giờ trước',
            unread: true,
          },
          {
            title: 'Đề xuất công việc thành công',
            message: 'Ứng viên Phạm Duy Kiên đã đồng ý nhận Offer và bắt đầu làm việc ngày 30/05.',
            time: '1 ngày trước',
            unread: false,
          },
        ].map((notif, i) => (
          <div key={i} className={cn("p-5 flex items-start justify-between gap-4 transition-colors", notif.unread && "bg-orange-50/20")}>
            <div className="space-y-1.5 font-semibold">
              <div className="flex items-center gap-2">
                {notif.unread && <div className="w-2 h-2 bg-[#f97316] rounded-full" />}
                <h4 className="font-bold text-gray-800 text-sm">{notif.title}</h4>
              </div>
              <p className="text-xs text-gray-600 font-medium leading-relaxed">{notif.message}</p>
              <span className="text-[10px] text-gray-400 font-bold block">{notif.time}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecruiterNotificationsTab;
